import { render, staticRenderFns } from "./BadgeMitra.vue?vue&type=template&id=3da901b8&scoped=true&"
import script from "./BadgeMitra.vue?vue&type=script&lang=js&"
export * from "./BadgeMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da901b8",
  null
  
)

export default component.exports